export const featureDataHighRiseMidRiseProjects = {
    mainTitle: 'Why Choose HRD for High-Rise & Mid-Rise Services?',
    items: [
        {
            number: '01',
            heading: 'Industry-Leading Expertise – Over 20 years of experience in high-rise restoration and maintenance.'
        },
        {
            number: '02',
            heading: 'Advanced Access Methods – Certified in swing stage, scaffolding, and rope access for efficient execution.'
        },
        {
            number: '03',
            heading: 'Minimal Disruption – Strategically planned work to limit impact on tenants and business operations.'
        },
        {
            number: '04',
            heading: 'Premium Materials & Techniques – Using high-performance coatings, sealants, and waterproofing systems.'
        },
         {
            number: '05',
            heading: 'Safety & Compliance – Strict adherence to WorkSafeBC regulations and industry best practices.'
        }
    ],
    title: "Building Excellence at Every Level",
    subtitle:
        'From commercial skyscrapers to mid-rise office and mixed-use buildings, we provide expert restoration solutions to protect, enhance, and extend the life of your investment.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/4HighRiseMidRiseProjects/featuregridSection/fondo.png'
};
